module.exports = __webpack_public_path__ + "static/media/ehealth_adolescent_banner_desktop.ce91d463.png";